<template>
    <div>
        <portlet :clase="'container col-md-12 blockui_sample_3_2_element'">
            <template slot="actions">
                <a class="btn btn-circle btn-icon-only btn-success" :href="link_download" title='Descargar Excel'><i class="fa fa-file-excel-o"></i></a>
                <a class="btn btn-circle btn-icon-only btn-default" href="#portlet-edit" data-toggle='modal'
                    title='Agregar registro' v-on:click="nuevoRegistro()"><i class="fa fa-plus"></i></a>
            </template>
            <template slot="caption">
                <div class="row">
                    <div class='col-md-6'>
                        <span class="caption-subject bold uppercase">
                            <i class="fa fa-database"></i> Autorización de declaraciones con saldo a favor
                            &nbsp;<a class="btn btn-circle btn-icon-only btn-default" title='Recargar registros'
                                v-on:click="loadTableSample()"><i class="fa fa-rotate-left"></i></a>
                        </span>
                    </div>
                </div>
            </template>
            <template slot="body">
                <div class="row">
                    <tableSample :lengthMenu="lengthMenu" @detalle="editarRegistro" @eliminar="abrirModalEliminar" @ver="accionVer" :data_="data_" :id="'sample_2'" v-if="renderTable" />
                </div>
            </template>
        </portlet>

        <modal :id="'portlet-edit'" :modal="'modal-lg'">
            <template slot="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
                    v-on:click="limpiarInputs()"></button>
                <h4 class="modal-title"><i class="fa fa-cogs"></i> AUTORIZACIÓN DE DECLARACIONES CON SALDO A FAVOR</h4>
            </template>
            <template slot="modal-body">
                <div class="row">
                    <portlet :clase="'container col-md-12 blockui_sample_3_2_element'">
                        <template slot="tools">
                            <a href="" class="collapse" data-original-title="" title=""></a>
                        </template>
                        <template slot="caption">
                            <h4><strong>Datos Generales</strong></h4>
                        </template>
                        <template slot="body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="numero_oficio">Número de oficio *</label>
                                            <input type="text" name="numero_oficio" class="form-control"
                                                v-model="numero_oficio"
                                                autocomplete="off"
                                                :disabled="inputDisable == false">
                                            <span class="help-block" style="color:red;">{{ oficio_valid }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="fecha_oficio">Fecha del oficio *</label>
                                            <input type="date" name="fecha_oficio" id="fecha_oficio"
                                                class="form-control" v-model="fecha_oficio"
                                                :disabled="inputDisable == false">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="rfc">RFC del contribuyente *</label>
                                            <input type="text" class="form-control" name="rfc" v-model="rfc"
                                                maxlength="13" @keypress="validaLetrasNumeros($event)"
                                                autocomplete="off" v-on:input="obligaciones()" :disabled="inputDisable == false">
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="cuenta">Cuenta</label>
                                            <input type="text" class="form-control" name="cuenta"
                                                v-model="cuenta" @keypress="validaNumero($event)"
                                                autocomplete="off" v-on:input="obligaciones()" :disabled="inputDisable == false">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label for="nombre_razon_social">Nombre o razón social</label>
                                            <input type="text" class="form-control" name="nombre_razon_social"
                                                placeholder="Nombre o Razón social" v-model="nombre_razon_social"
                                                @keypress="validaLetras($event)" autocomplete="off" :disabled="true">
                                            <span class="help-block text-danger">{{ verifica_obligacion }}</span>
                                        </div>
                                    </div>

                                </div>
                                <div class="col-md-12">
                                    <h4><strong>Datos de la declaración sobre la cual se autoriza el saldo a
                                            favor</strong></h4>
                                    <hr>
                                </div>
                                <div class="col-md-12">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="no_folio">Número de folio *</label>
                                            <input type="text" name="no_folio" id="no_folio" class="form-control"
                                                v-model="no_folio" maxlength="10"
                                                @keypress="validaNumero($event)"
                                                autocomplete="off" :disabled="inputDisable == false"
                                                v-on:input="buscarDeclaracionPorFolio()">
                                            <span class="help-block text-danger">{{ verifica_folio }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="periodo">Periodo</label>
                                            <input type="text" name="periodo" id="periodo" class="form-control"
                                                v-model="periodo" maxlength="8" @keypress="validaNumero($event)"
                                                autocomplete="off" :disabled="true">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="obligacion">Obligación</label>
                                            <input type="text" name="obligacion" id="obligacion" class="form-control"
                                                v-model="obligacion" maxlength="13"
                                                @keypress="validaLetrasNumeros($event)"
                                                autocomplete="off" :disabled="true">
                                            <span class="help-block" style="color:red;">{{ oficio_valid }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="tipo_declaracion">Tipo de declaración</label>
                                            <input type="text" name="tipo_declaracion" id="tipo_declaracion"
                                                class="form-control" v-model="tipo_declaracion" maxlength="8"
                                                @keypress="validaNumero($event)" autocomplete="off" :disabled="true">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="impuesto_total">Impuesto total efectivamente pagado</label>
                                            <input type="text" name="impuesto_total" id="impuesto_total"
                                                class="form-control" v-model="impuesto_total" maxlength="13"
                                                @keypress="validaLetrasNumeros($event)"
                                                autocomplete="off" :disabled="true">
                                            <span class="help-block" style="color:red;">{{ oficio_valid }}</span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="impuesto_maximo">Impuesto máximo de saldo a favor a generar
                                                *</label>
                                            <input type="text" name="impuesto_maximo" id="impuesto_maximo"
                                                class="form-control" v-model="impuesto_maximo" maxlength="8"
                                                @keypress="validaNumero($event)" autocomplete="off"
                                                :disabled="inputDisable == false">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="fecha_limite">Fecha hasta la cual surte efecto *</label>
                                            <input type="date" name="fecha_limite" id="fecha_limite"
                                                class="form-control" v-model="fecha_limite" maxlength="13"
                                                @keypress="validaLetrasNumeros($event)"
                                                autocomplete="off" :disabled="inputDisable == false">
                                            <span class="help-block" style="color:red;">{{ oficio_valid }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 form-group" v-if="url_documento_oficio">
                                    <label>Oficio Adjunto</label>
                                    <div>
                                        <a :href="url_documento_oficio" target="_blank" class="btn green">
                                            <i class="fa fa-download"></i> Ver/Descargar Archivo
                                        </a>
                                    </div>
                                </div>
                                <div class="col-md-12" v-if="modoModal !== 'ver'">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="archivo_oficio">Adjuntar Oficio (PDF)</label>
                                            <input type="file" name="archivo_oficio" id="archivo_oficio" class="form-control" @change="seleccionarArchivo" accept="application/pdf" ref="campoArchivo">
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <span class="help-block">&nbsp;</span>
                                    <div class="form-group">
                                        <button class="btn blue" v-if="mostrarBoton" v-on:click="updateSaveRegistro()">
                                            <i class="fa fa-check"></i> Guardar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </portlet>
                </div>
            </template>
            <template slot="modal-footer">
                <button type="button" data-dismiss="modal" class="btn default"
                    v-on:click="limpiarInputs()">Cerrar</button>
            </template>
        </modal>
        <modal :id="'portlet-del'" :modal="'modal-lg'">
            <template slot="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true"
                    v-on:click="limpiarInputs()"></button>
                <h4 class="modal-title">Detalle del registro a eliminar</h4>
            </template>
            <template slot="modal-body">
                <div class="row">
                    <portlet :clase="'container col-md-12 blockui_sample_3_2_element'">
                        <template slot="body">
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>No. de oficio:</strong> {{ numero_oficio }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>RFC:</strong> {{ rfc }}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <p><strong>Cuenta:</strong> {{ cuenta }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Nombre o razón social:</strong> {{ nombre_razon_social }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Número de folio:</strong> {{ no_folio }}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <p><strong>Tipo de declaración:</strong> {{ tipo_declaracion }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Obligación:</strong> {{ obligacion }}</p>
                                    </div>
                                    <div class="col-md-6">
                                        <p><strong>Periodo:</strong> {{ periodo }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Impuesto total efectivamente pagado:</strong> {{ impuesto_total }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <p><strong>Importe máximo de saldo a favor a generar:</strong> {{ impuesto_maximo }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="motivo_eliminacion">Motivo de eliminación *</label>
                                            <select name="motivo_eliminacion" id="motivo_eliminacion" class="form-control" v-model="motivo_eliminacion">
                                                <option value="" disabled>-- Seleccione una opción --</option>
                                                <option value="Corrección de datos">Corrección de datos</option>
                                                <option value="Cancelación de registro">Cancelación de registro</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label for="fecha_eliminacion">Fecha de eliminación *</label>
                                            <input type="date" name="fecha_eliminacion" id="fecha_eliminacion"
                                                class="form-control" v-model="fecha_eliminacion" autocomplete="off"
                                                :disabled="true">
                                        </div>
                                    </div>
                                </div>
                        </template>
                    </portlet>
                </div>
            </template>
            <template slot="modal-footer">
                <button type="button" data-dismiss="modal" class="btn default" v-on:click="limpiarInputs()">Cancelar
                </button>
                <button type="button" class="btn green" v-on:click="eliminarRegistro()">
                    <i class="fa fa-check"></i> Aceptar
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import axios from 'axios'
import select2 from './General/Select.vue'
import portlet from './General/Portlet.vue'
import modal from './General/Modal.vue'
import modalconfirmation from './General/ModalConfirmation.vue'
import tableSample from './Individual/TableAutorizacionDeclaraciones.vue'
import VCalendar from 'v-calendar'
export default {
    name: 'ReporteEstadistica',
    components: { axios, select2, portlet, modal, modalconfirmation, tableSample, VCalendar },
    data() {
        return {
            lengthMenu: [[10, 25, 50, -1], [10, 25, 50, 'All']],
            options: [],
            data_: [],
            url_documento_oficio: '',
            modoModal: '',
            id_registro: '',
            numero_oficio: '',
            fecha_oficio: '',
            rfc: '',
            cuenta: '',
            nombre_razon_social: '',
            no_folio: '',
            periodo: '',
            obligacion: '',
            tipo_declaracion: '',
            impuesto_total: '',
            impuesto_maximo: '',
            fecha_limite: '',
            fecha: '',
            mostrarBoton: true,
            cantidad_maquinas: '',
            carga_inicial: 0,
            prorrateo_200: 0,
            prorrateo_300: 0,
            renderTable: false,
            inputDisable: false,
            link_download: `${process.env.APP_URL}/download-declaracion`,
            rfc_valid: '',
            verifica_obligacion: '',
            verifica_folio: '',
            hidden_input: false,
            hidden_input_cuotas: false,
            motivo_eliminacion: '',
            fecha_eliminacion: '',
            archivo_oficio: null,
            debounceTimer: null,
        }
    },
    methods: {
        seleccionarArchivo(event) {
            this.archivo_oficio = event.target.files[0];
        },
        handleFileUpload(event) {
            this.file = event.target.files[0];
        },
        loadTableSample() {
            this.renderTable = false
            this.loagingC(true);
            this.data_ = [];
            axios.get(`${process.env.APP_URL}/find-declaraciones`)
                .then((response) => {
                    this.data_ = response.data.response;
                    this.renderTable = true
                    this.loagingC(false);
                })
                .catch(error => {
                    console.log(error);
                    this.loagingC(false);
                });
        },
        accionVer(dato) {
            this.modoModal = 'ver';
            this.mostrarBoton = false;
            this.inputDisable = false;
            this.id_registro = dato.id;
            this.numero_oficio = dato.numero_oficio;
            this.fecha_oficio = dato.fecha_oficio;
            this.rfc = dato.rfc;
            this.cuenta = dato.numero_cuenta;
            this.nombre_razon_social = dato.nombre_razon_social;
            this.no_folio = dato.folio_declaracion;
            this.periodo = dato.periodo_declarado;
            this.obligacion = dato.obligacion_fiscal;
            this.tipo_declaracion = dato.tipo_declaracion;
            this.impuesto_total = dato.impuesto_total_pagado;
            this.impuesto_maximo = dato.importe_maximo_saldo_favor;
            this.fecha_limite = dato.fecha_vigencia;
            this.url_documento_oficio = dato.url_documento_oficio;
            $('#portlet-edit').modal('show');
            this.$emit('ver', dato);
        },
        editarRegistro(dato) {
            this.modoModal = '';
            this.mostrarBoton = true;
            this.inputDisable = true;
            this.id_registro = dato.id;
            this.numero_oficio = dato.numero_oficio;
            this.fecha_oficio = dato.fecha_oficio;
            this.rfc = dato.rfc;
            this.cuenta = dato.numero_cuenta;
            this.nombre_razon_social = dato.nombre_razon_social;
            this.no_folio = dato.folio_declaracion;
            this.periodo = dato.periodo_declarado;
            this.obligacion = dato.obligacion_fiscal;
            this.tipo_declaracion = dato.tipo_declaracion;
            this.impuesto_total = dato.impuesto_total_pagado;
            this.impuesto_maximo = dato.importe_maximo_saldo_favor;
            this.fecha_limite = dato.fecha_vigencia;
            this.url_documento_oficio = dato.url_documento_oficio;
            this.$forceUpdate();

        },
        nuevoRegistro() {
            this.mostrarBoton = true;
            this.inputDisable = true;
            this.modoModal = '';
            this.limpiarInputs();
        },
        limpiarInputs() {
            this.id_registro = '';
            this.numero_oficio = '';
            this.fecha_oficio = '';
            this.rfc = '';
            this.cuenta = '';
            this.nombre_razon_social = '';
            this.no_folio = '';
            this.periodo = '';
            this.obligacion = '';
            this.tipo_declaracion = '';
            this.impuesto_total = '';
            this.impuesto_maximo = '';
            this.fecha_limite = '';
            this.motivo_eliminacion = '';
            this.archivo_oficio = null;
            this.url_documento_oficio = null;

            if (this.$refs.campoArchivo) {
                this.$refs.campoArchivo.value = '';
            }
        },
        abrirModalEliminar(dato) {
            this.id_registro = dato.id;
            this.numero_oficio = dato.numero_oficio;
            this.rfc = dato.rfc;
            this.cuenta = dato.numero_cuenta;
            this.nombre_razon_social = dato.nombre_razon_social;
            this.no_folio = dato.folio_declaracion;
            this.tipo_declaracion = dato.tipo_declaracion;
            this.obligacion = dato.obligacion_fiscal;
            this.periodo = dato.periodo_declarado;
            this.impuesto_total = dato.impuesto_total_pagado;
            this.impuesto_maximo = dato.importe_maximo_saldo_favor;
            this.fecha_eliminacion = new Date().toISOString().split('T')[0];
            $('#portlet-del').modal('show');
        },
        obligaciones() {
            if (this.rfc) {
                this.rfc = this.rfc.toUpperCase();
            }

            clearTimeout(this.debounceTimer);

            if (this.id_registro !== "") {
                return;
            }

            this.debounceTimer = setTimeout(() => {

            if (!this.rfc || !this.cuenta) {
                this.nombre_razon_social = '';
                return;
            }

            this.verifica_obligacion="Consultando...";
            axios.get(`${process.env.APP_URL}/wsapi-obligaciones/${this.rfc}/${this.cuenta}`)
                .then((response)=>{
                    if (response.data &&
                        response.data.Message &&
                        response.data.Message.Data &&
                        response.data.Message.Data.datosGeneralesInternet &&
                        response.data.Message.Data.datosGeneralesInternet.NOMBRE
                    ){
                        this.nombre_razon_social=response.data.Message.Data.datosGeneralesInternet.NOMBRE;
                    }else{
                        this.nombre_razon_social="";
                        this.notifications("400", "Favor de validar el RFC – Cuenta capturado.");
                    }
                    this.verifica_obligacion="";
                })
                .catch(error=>{
                    console.log(error);
                    this.nombre_razon_social="";
                    this.verifica_obligacion="";
                    this.notifications("400", "La consulta al REC no está disponible.");
                });

        }, 1000);

        },
        async buscarDeclaracionPorFolio() {
            this.periodo = '';
            this.obligacion = '';
            this.tipo_declaracion = '';
            this.impuesto_total = '';

            if (!this.no_folio && !this.rfc) {
                this.periodo = '';
                return;
            }

            try {

                this.verifica_folio = "Buscando información del folio...";

                const url = `${process.env.APP_URL}/wsapi-declaraciones/${this.no_folio}/${this.rfc}/${this.cuenta}`;
                const response = await axios.get(url);

                if (response.data && response.data.idTrans) {

                    if (String(response.data.idTrans) !== String(this.no_folio)) {
                        console.log("ASDF" + response.data.idTrans + "=======" + this.no_folio)
                        this.notifications("400", "El folio capturado no corresponde al folio de la última declaración presentada para este periodo, favor de validarlo.");
                        return;
                    }
                }

                if (response.data.estimulos && parseFloat(response.data.estimulos) > 0) {

                    this.notifications("400", "El folio capturado corresponde a una declaración que cuenta con un Estímulo, reducción o compensación aplicado, favor de validarlo.");

                    this.verifica_folio = "";
                    return;
                }

                if (response.data.pago_exceso && parseFloat(response.data.pago_exceso) > 0) {

                    this.notifications("400", "El folio capturado corresponde a una declaración que cuenta con un Pago en exceso generado, favor de validarlo.");

                    this.verifica_folio = "";
                    return;
                }

                if(response.data.Code === "no_conciliado"){
                    this.notifications("400", response.data.Message);
                    return
                }

                const { anio, mes } = response.data;

                if (anio && mes) {
                    const meses = [
                        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
                        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
                    ];
                    const nombreMes = meses[mes - 1];

                    this.periodo = `${nombreMes}-${anio}`;
                } else {
                    this.periodo = '';
                }
                this.obligacion = response.data.Tipo_Descripcion;
                this.tipo_declaracion = response.data.tipo_declaracion;
                this.impuesto_total = response.data.impuesto;

                this.verifica_folio = "";

            } catch (error) {
                if (error.response && error.response.data && error.response.data.Message) {
                    this.notifications("400", error.response.data.Message);
                } else {
                    console.error("Error al buscar la declaración por folio:", error);
                }
                this.periodo = '';
                this.verifica_folio = "No se pudo encontrar la información del folio.";
            }
        },
        validForm() {
            if (this.numero_oficio.length == 0) {
                this.notifications("400", "Número de oficio, requerido!");
                return true;
            } else if (this.fecha_oficio.length == 0) {
                this.notifications("400", "Fecha del oficio, requerido!");
                return true;
            } else if (this.fecha_oficio > new Date().toISOString().split('T')[0]) {
                this.notifications("400", "La fecha de oficio no puede ser una fecha futura.");
                return true;
            } else if (!this.rfcValido(this.rfc)) {
                this.notifications("400", "Formato RFC, requerido!");
                return true;
            } else if (this.cuenta.length == 0) {
                this.notifications("400", "Cuenta, requerido!");
                return true;
            } else if (this.nombre_razon_social.length == 0) {
                this.notifications("400", "Nombre o Razón social, requerido!");
                return true;
            } else if (this.no_folio.length == 0) {
                this.notifications("400", "Número de folio, requerido!");
                return true;
            } else if (!/^\d+$/.test(this.no_folio)) {
                this.notifications("400", "El folio capturado no cumple con la estructura correspondiente, favor de validarlo.");
                return true;
            } else if (this.impuesto_maximo.length == 0) {
                this.notifications("400", "Impuesto máximo de saldo a favor a generar, requerido!");
                return true;
            } else if (parseFloat(this.impuesto_maximo) <= 0) {
                this.notifications("400", "El impuesto máximo debe ser un valor mayor a cero.");
                return true;
            } else if (this.fecha_limite.length == 0) {
                this.notifications("400", "Fecha hasta la cual surte efecto, requerida!");
                return true;
            } else if (this.fecha_limite < this.fecha_oficio) {
                this.notifications("400", "La fecha límite no puede ser anterior a la fecha de oficio.");
                return true;
            } else if (this.fecha_limite < new Date().toISOString().split('T')[0]) {
                this.notifications("400", "La fecha límite no puede ser anterior a la fecha actual.");
                return true;
            } else if (isNaN(new Date(this.fecha_oficio).getTime()) || new Date(this.fecha_oficio).getFullYear() < 2000) {
                this.notifications("400", "La fecha de oficio no es válida.");
                return true;
            } else if (isNaN(new Date(this.fecha_limite).getTime()) || new Date(this.fecha_limite).getFullYear() < 2000) {
                this.notifications("400", "La fecha límite no es válida.");
                return true;
            } else if (!this.id_registro && !this.archivo_oficio) {
                this.notifications("400", "El archivo de oficio es obligatorio.");
                return true;
            } else if (parseFloat(this.impuesto_maximo) > parseFloat(this.impuesto_total)) {
                this.notifications("400", "El impuesto máximo no puede ser mayor al impuesto total pagado.");
                return true;
            }
            return false;
        },
        updateSaveRegistro() {
            if (this.validForm()) {
                return;
            }

            const formData = new FormData();

            formData.append('id', this.id_registro);
            formData.append('numero_oficio', this.numero_oficio);
            formData.append('fecha_oficio', this.fecha_oficio);
            formData.append('rfc', this.rfc);
            formData.append('cuenta', this.cuenta);
            formData.append('nombre_razon_social', this.nombre_razon_social);
            formData.append('no_folio', this.no_folio);
            formData.append('periodo', this.periodo);
            formData.append('obligacion', this.obligacion);
            formData.append('tipo_declaracion', this.tipo_declaracion);
            formData.append('impuesto_total', this.impuesto_total);
            formData.append('impuesto_maximo', this.impuesto_maximo);
            formData.append('fecha_limite', this.fecha_limite);

            if (this.archivo_oficio) {
                formData.append('archivo_oficio', this.archivo_oficio);
            }

            axios.post(`${process.env.APP_URL}/insert-update-declaracion`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                this.notifications(response.data.status, response.data.message);
                this.loadTableSample();
                if (this.id_registro.length == 0) {
                    this.limpiarInputs();
                }
            })
            .catch(error => {
                this.notifications("400", error.response.data.message);
                console.log(error.response);
            });
        },
        eliminarRegistro() {
            if (!this.motivo_eliminacion || this.motivo_eliminacion.trim() === '') {
                this.notifications("400", "El motivo de eliminación es obligatorio.");
                return;
            }
            axios.post(`${process.env.APP_URL}/delete-declaracion`, {
                id: this.id_registro,
                motivo_eliminacion: this.motivo_eliminacion,
                fecha_eliminacion: this.fecha_eliminacion,
            })
                .then((response) => {
                    this.notifications(response.data.status, response.data.message);
                    this.loadTableSample();
                    this.limpiarInputs();
                    $('#portlet-del').modal('hide');
                })
                .catch(error => {
                    console.log(error);
                }
                );
        },

        rfcValida() {
            this.rfc = this.rfc.toUpperCase();
            if (this.rfc.length < 12) { this.curp_valid = ''; return; }
            let vald = this.rfcValido(this.rfc, true);
            if (vald) {
                this.rfc_valid = "";
            } else {
                this.rfc_valid = "Formato incorrecto";
            }
        },
        rfcValido(rfc, aceptarGenerico = true) {
            rfc = rfc.toUpperCase();
            const re = /^([A-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A-Z\d])$/;
            var validado = rfc.match(re);
            if (!validado)
                return false;
            return true;
        },
        validaLetrasNumeros($event) {
            if (/[a-zA-Z0-9]/g.test($event.key)) {
                return true;
            } else { $event.preventDefault() }
        },
        validaLetras($event) {
            if (/[A-Za-z ÁÉÍÓÚáéíóúÑñ]/g.test($event.key)) {
                return true;
            } else { $event.preventDefault() }
        },
        validaNumero($event) {
            if (/[0-9]/g.test($event.key)) {
                return true;
            } else { $event.preventDefault() }
        },
        loagingC(value, index, values) {
            return Vue.filter('loadingCharge')(value);
        },
        notifications(Code, Message) {
            if (Code == "200") {
                Command: toastr.success(Message, "Notifications");
            } else {
                Command: toastr.warning(Message, "Notifications");
            }
        }
    },
    mounted() {
        this.loadTableSample();
    }
}
</script>
